function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-11,.cls-12,.cls-2,.cls-7,.cls-8{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-7{stroke:#e5e5e5;}.cls-2{stroke-width:4.36px;}.cls-3{fill:#fefddb;}.cls-4{fill:#b2f5ea;}.cls-5{fill:#ed8936;}.cls-10,.cls-6{fill:#8ce08c;}.cls-7{stroke-width:3.06px;}.cls-8{stroke:#2b7c63;stroke-width:3.65px;}.cls-9{fill:#2b7c63;}.cls-10{fill-rule:evenodd;}.cls-11{stroke:#fff;}.cls-11,.cls-12{stroke-width:5.14px;}.cls-12{stroke:#b2f5ea;}.cls-13{fill:#777;}.cls-14{fill:#c2c2c2;}.cls-15{fill:#fff;}\n"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "vector"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M557.12,128.2C632,169.45,726.21,224.89,739.5,293.63S685.27,444.54,610.43,508.85s-157,111.2-226.83,99S256.21,524.43,183,460c-73-64.46-161.45-122-179.48-197.65S38.09,93.07,111.1,51.83s166.64-30.09,241.18-11S482.27,87,557.12,128.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M354,24.12,6.15,389.58,613.66,508Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 140.07,
  width: 392.22,
  height: 360.24
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "165.06 9.9 150.11 35.78 180 35.78 165.06 9.9"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-5",
  cx: 202.77,
  cy: 21.84,
  r: 14.33
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 230.28,
  y: 8.69,
  width: 27.09,
  height: 27.09
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-7",
  x1: 119.59,
  y1: 46.78,
  x2: 532.7,
  y2: 46.78
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M708.62,446.31H504.56a31,31,0,0,1-31-31V211.28a31,31,0,0,1,31-31H708.62a31,31,0,0,1,31,31V415.34A31,31,0,0,1,708.62,446.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M277.54,303.14c108.16,0,108.16,217.58,97.54,236.82S201,556.28,188.91,540,172.2,303.14,277.54,303.14Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-6",
  cx: 273.48,
  cy: 207.17,
  r: 58.86
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M309.66,185.71c-.86-6-3.84-10.56-6.63-10.15s-4.37,5.6-3.5,11.61,3.84,10.57,6.63,10.16S310.53,191.73,309.66,185.71Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-9",
  cx: 241.86,
  cy: 95.74,
  r: 36.81
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M299.92,336.72a35.34,35.34,0,1,1,35.34,35.33A35.34,35.34,0,0,1,299.92,336.72Z"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-11",
  points: "473.59 372.05 524.96 320.68 545.59 341.31 612.59 274.31 642.09 303.81 709.59 236.31 738.66 265.38"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M37.09,356.81c0-16.11,26-16.11,26-32.22s-26-16.11-26-32.22,26-16.1,26-32.21-26-16.11-26-32.22,26-16.12,26-32.23-26-16.11-26-32.22,26-16.11,26-32.22-26-16.12-26-32.23,26-16.11,26-32.23"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M523.92,336.72a35.34,35.34,0,1,1,35.34,35.33A35.34,35.34,0,0,1,523.92,336.72Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 471.09,
  y: 534.81,
  width: 193,
  height: 15
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "676.93 542.31 663.94 534.81 663.94 549.81 676.93 542.31"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "672.05 539.5 672.05 545.13 676.93 542.31 672.05 539.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M276.2,553.21a98.69,98.69,0,0,1,98.69-97.55c.81,0,1.62,0,2.42,0"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M254.56,307.07a98.7,98.7,0,0,1-59.88,177.16,101.37,101.37,0,0,1-11.89-.7"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-13",
  points: "361.59 530.31 238.59 530.31 238.59 600.31 275.59 600.31 361.59 530.31"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 13.59,
  y: 433.31,
  width: 262,
  height: 167
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-15",
  cx: 144.59,
  cy: 516.81,
  r: 18
})));

var SvgWatermelonPackIllustration18 = function SvgWatermelonPackIllustration18(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 741.23 609.78",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWatermelonPackIllustration18, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/watermelon-pack-illustration-18.606d8d43.svg";
export { ForwardRef as ReactComponent };